import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { memoize } from "nodash"
import { selectOpenPlaybackEntities } from "plugins/shared/playback/state/selectors"
import { userLocationShareSliceName } from "./slice"

export const selectOpenUserLocationShareIds = createSelector(
    [selectOpenPlaybackEntities],
    (entities) => entities.filter((e) => e.type === "locationShare").map((e) => e.id)
)
export const selectIsUserLocationShareOpen = memoize((id: string) =>
    createSelector([selectOpenUserLocationShareIds], (ids) => ids.includes(id))
)

const root = (s: RootState) => s[userLocationShareSliceName]

export const selectUserLocationShareNodeEnabledMap = createSelector(
    [root],
    (s) => s.nodeEnabledByShareId
)
export const selectIsUserLocationShareNodeEnabled = memoize((id: string) =>
    createSelector([root], (s) => s.nodeEnabledByShareId[id] !== false)
)

export const selectUserLocationSharePathEnabledMap = createSelector(
    [root],
    (s) => s.pathEnabledByShareId
)
export const selectIsUserLocationSharePathEnabled = memoize((id: string) =>
    createSelector([root], (s) => s.pathEnabledByShareId[id] !== false)
)
